import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserTeams } from "../../services/team.services";
import "./TeamsModal.css";

const TeamsListModal = (props) => {
  const [teams, setTeams] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);

  const user = useSelector((state) => state.auth.user);

  const handleGetAllTeams = async () => {
    try {
      setLoading(true);
      const response = await getUserTeams(user._id, user?.token);
      console.log("user teams::::: ", response.data);
      setTeams(response.data);
    } catch (error) {
      console.error("Error fetching teams:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
  props.setSelectedTeams(selectedTeams); // keep full objects for display
  props.handleFormChange("teams", selectedTeams.map(t => t._id)); // send only IDs to form
  props.onBackdropPress();
};


  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      props.onBackdropPress();
    }
  };

  useEffect(() => {
    handleGetAllTeams();
  }, []);

  return (
    <div 
      className={`modal-overlay ${props.isVisible ? "visible" : ""}`}
      onClick={handleBackdropClick}
    >
      <div className="modal-content">
        <h2 className="modal-heading">Select Teams</h2>
        
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading teams...</p>
          </div>
        ) : (
          <div className="teams-list">
            {teams?.map((val, ind) => {
              const isSelected = selectedTeams.some(team => team._id === val._id);

              return (
                <div
                  key={ind}
                  className={`team-item ${isSelected ? "selected" : ""}`}
                  onClick={() =>
                    setSelectedTeams(prev =>
                      isSelected
                        ? prev.filter(team => team._id !== val._id)
                        : [...prev, val]
                    )
                  }
                >
                  <span className="team-name">{val.teamName}</span>
                </div>
              );
            })}
          </div>
        )}

        <button 
          onClick={handleSave} 
          className="save-button"
          disabled={loading}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default TeamsListModal;